import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Divider, Empty, Card, Tooltip } from "antd";
import { Wrapper, ThreeBox } from "./styles";
import RenderFigureData from "../../components/render-figure-data/index2";
import EjeFinal from "../../img/Eje-Final.jpg";
import RuedaFinal from "../../img/Rueda-Final.jpg";
import RenderDesingProcessData from "../../components/render-desing-process-data";
import useProcessDesings from "../../hooks/useProcessDesings";
import useManufacturingOrder from '../../hooks/useManufacturingOrder';
import Table from "../../components/table";
import Search from "../../components/table/search";
import ModalDesingAddArticle from './modalDesing';
import ModalDesingExtraData from "../../components/modal-desing-process";
import ModalDesingProcess from "../../components/modal-desing-process";
import { useTranslation } from 'react-i18next';

const RenderManufacturingOrder = ({ changeTitle }) => {
  const [listOfManufacturing, setListOfManufacturing] = useState([]);
  const [selectedManufacturing, setSelectedManufacturing] = useState(null);
  const [selectedRowKeyManufacturing, setSelectedRowKeyManufacturing] = useState([]);
  const [showModalDesingAddArticle, setShowModalDesingAddArticle] = useState(false);
  const [showModalExtraData, setShowModalExtraData] = useState(false);
  const [showModalDesing, setShowModalDesing] = useState(false);
  const { manufacturingOrder, updateData } = useManufacturingOrder();
  const { processDesings } = useProcessDesings();
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("manufacturig_order");
  }, [changeTitle]);


  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => !order.making);
    
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order
      };
    });

    normalized && setListOfManufacturing(normalized)

    if(normalized && normalized[0])  {
      setSelectedManufacturing(normalized[0]);
      setSelectedRowKeyManufacturing([normalized[0].key]);
    }
  }, [manufacturingOrder]);


  const columnsManufacturing = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend",
      ...Search("ref")
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "article.articleName"
    },
    {
      title: t('table.header.n_articles'),
      dataIndex: "articlesNumber",
      key: "articlesNumber",
      sorter: (a, b) => a.articlesNumber-b.articlesNumber
    },
    {
      title: t('table.header.design'),
      dataIndex: "desing.desingName",
      key: "desing",
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip style={{cursor: "pointer"}} onClick={() => !record.making && setShowModalDesingAddArticle(true)} title={record.making ? t('button.action.manufacturing_in_progress') : t('button.action.link_design')}>
            <Icon type="link" style={{ color: record.making ? "#ccc" : "#3498db", cursor: "pointer" }} />{" "}
            {record.desing ? <span style={{ color: "#3498db", cursor: "pointer" }}>{record.desing.desingName}</span> : <span style={{ cursor: "pointer" }}>{t('button.action.not_linked')}</span>}
          </Tooltip>
        </Row>
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKeyManufacturing,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeyManufacturing(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedManufacturing(listOfManufacturing.find(obj => obj.id === record.id));
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
    },
    type: "radio"
  };
  
  const clickRow = row => {
    setSelectedRowKeyManufacturing([row.key]);
    setSelectedManufacturing(listOfManufacturing.find(obj => obj.id === row.id));
  };
  
  const handleShowModalDesingAddArticle = visible => setShowModalDesingAddArticle(visible);
  const handleShowModalExtraData = visible => setShowModalExtraData(visible);
  const handleShowModalDesing = visible => setShowModalDesing(visible);

  const setLink = (id) => {
    let copy = manufacturingOrder.find(obj => obj.id === selectedManufacturing.id)
    copy.desingId = id;
    copy.desing = processDesings.find(obj => obj.id === id);
    updateData(copy)
  }

  return (
    <Wrapper>
      <Row style={{ margin: 0, height: "100%" }} gutter={[16, 16]}>
        <Col xl={12} lg={12} md={24}>
            <Table data={listOfManufacturing} columns={columnsManufacturing} rowSelection={rowSelection} onClick={() => clickRow} />
        </Col>
        <Col xl={12} lg={12} md={24} style={{ margin: 0 }}>
        
          <Card
            title={
              (selectedManufacturing && selectedManufacturing.ref ? selectedManufacturing.ref : "")
              + "-" +
              (selectedManufacturing && selectedManufacturing.article && selectedManufacturing.article.articleName ? selectedManufacturing.article.articleName : "")
              + "-" +
              (selectedManufacturing && selectedManufacturing.desing && selectedManufacturing.desing.desingName ? selectedManufacturing.desing.desingName : t('button.action.not_linked') )
            }
          >
            <Row style={{ margin: 0 }} gutter={[16, 16]}>
              <Col xl={24} lg={24} md={24}>
                <ThreeBox>
                  {selectedManufacturing && selectedManufacturing.article && selectedManufacturing.article.figure[0] && <RenderFigureData selectedArticle={selectedManufacturing.article} src={selectedManufacturing.article && selectedManufacturing.article.figure === "eje" ?EjeFinal:RuedaFinal}/>}
                </ThreeBox>
              </Col>
            </Row>
            <Divider/>
            <Row style={{ margin: 0 }} gutter={[16, 16]}>
              <Col xl={24} lg={24} md={24}>
                {selectedManufacturing && selectedManufacturing.desing ? 
                  <RenderDesingProcessData selectedProcessDesing={selectedManufacturing.desing} setModal={() => setShowModalDesing(true)} isFisrt={true}/>
                  :
                  <Empty
                  image={<Icon type="disconnect" style={{ fontSize: 120 }} />}
                  imageStyle={{
                      height: 120,
                    }}
                    description={
                      <h3>
                        {t('text.design_no_linked')}
                      </h3>
                    }
                  >
                    {t('text.text_no_linked')}
                  </Empty>
                }
              </Col>
            </Row>
          </Card>
        </Col>
        <ModalDesingAddArticle visible={showModalDesingAddArticle} handleVisible={handleShowModalDesingAddArticle} manufacturing={selectedManufacturing && selectedManufacturing} article={selectedManufacturing && selectedManufacturing.article} setLink={setLink} setModal={() => setShowModalDesing(true)}/>
        <ModalDesingExtraData visible={showModalExtraData} handleVisible={handleShowModalExtraData} desing={selectedManufacturing && selectedManufacturing.desing ? selectedManufacturing.desing: selectedManufacturing} />
        <ModalDesingProcess visible={showModalDesing} handleVisible={handleShowModalDesing} desing={selectedManufacturing && selectedManufacturing.desing ? selectedManufacturing.desing: selectedManufacturing} />
      </Row>
    </Wrapper>
  );
};
export default RenderManufacturingOrder;
